<template lang="pug">
  modal(@hide="$emit('hide')" width='500px' modal-class='u-bg-primary u-p3')
    div(slot='content' class='u-px4')
      h3(class='u-fz-h2 u-mt0 u-center u-line-1 u-mb4')
        span(class='u-white') Reserva un Pavill para&nbsp;
        span(class='u-color-secondary') Delivery

      input-validate(
        v-model='form.fullname', :rule='rules.fullname' name='fullname' icon='user' placeholder='Nombres y apellidos', :validation='toggleValidate'
        wrapper-class='c-input c-input--icon' class='u-mb3' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

      input-validate(
        v-model='form.whatsapp', :rule='rules.whatsapp' name='whatsapp' icon='whatsapp' placeholder='Whatsapp', :validation='toggleValidate'
        wrapper-class='c-input c-input--icon' class='u-mb3' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

      input-validate(
        v-model='form.placeOfPurchase', :rule='rules.placeOfPurchase' icon='location' placeholder='Lugar de compra', :validation='toggleValidate'
        wrapper-class='c-input c-input--icon' class='u-mb3' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

      input-validate(
        v-model='form.purchaseDescription', :rule='rules.purchaseDescription' placeholder='Descripción de la compra', type='textarea'
        :validation='toggleValidate' rows='3'  wrapper-class='c-input' class='u-mb3' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

      input-validate(
        v-model='form.destinyAddress', :rule='rules.destinyAddress' icon='transport' placeholder='¿A dónde llevo tu compra?', :validation='toggleValidate'
        wrapper-class='c-input c-input--icon' class='u-mb3' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

      input-validate(
        v-model='form.destinyReference', :rule='rules.destinyReference' placeholder='Referencia del lugar de destino', :validation='toggleValidate'
        wrapper-class='c-input' class='u-mb3' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

      button(class='c-btn--primary u-12/12 u-fw-s-bold u-mb3 u-fz-h4 u-mt2' @click='postForm') Realizar Reserva
</template>

<script>
  import Validator from 'validatorjs'
  import axios from 'axios'

  export default {
    data () {
      return {
        toggleValidate: false,
        formValidate: false,
        isLoading: false,
        form: {
          fullname: '',
          whatsapp: '',
          placeOfPurchase: '',
          purchaseDescription: '',
          destinyAddress: '',
          destinyReference: ''
        },
        rules: {
          fullname: 'required',
          whatsapp: 'required|phone',
          placeOfPurchase: 'required',
          purchaseDescription: 'required',
          destinyAddress: 'required',
          destinyReference: 'required'
        }
      }
    },

    methods: {
      postForm () {
        this.validate()

        if (this.formValidate && !this.isLoading) {
          this.isLoading = true
          axios.post(`https://radiotaxipavill.ddns.net:8015/enlacepavill/RegistrarPedidoDelivery.php`, this.form)
          axios.post(`${window.API_URL}/delivery`, this.form)
            .then((response) => {
              this.isLoading = false
              this.$emit('hide')
              this.$emit('success')
            })
            .catch(({response}) => {
              this.isLoading = false
              this.$emit('hide')
              this.$emit('error')
            })
        }
      },

      validate () {
        let validation = new Validator(this.form, this.rules)
        validation.passes()
        this.toggleValidate = !this.toggleValidate
        this.formValidate = validation.passes()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/shared/components/ModalDelivery.vue